import { Box, Button, Flex, Select, TextInput } from '@mantine/core';
import { IconRefresh, IconSearch, IconX } from '@tabler/icons-react';

export default function CustomSearch(props: any) {
  const {
    isState = false,
    searchWord,
    resetSearch,
    searchType,
    setSearchType,
    inputRef,
    handleSearch,
    onClickSearch,
    searchOptions = [],
    placeholder = '검색어를 입력해주세요.',
    showSearchButton = true,
    width = '400px',
    showResetButton = true,
    resetSearchInput,
  } = props;

  return (
    <Flex gap="xs">
      <Box style={{ position: 'relative' }}>
        {!isState && (
          <TextInput
            ref={inputRef}
            onKeyUp={handleSearch}
            placeholder={placeholder}
            rightSection={
              inputRef.current?.value === '' ? <IconSearch size={16} /> : <IconX onClick={resetSearchInput} size={16} />
            }
            w={width}
            styles={{
              input: { paddingInlineStart: '8.5rem' },
            }}
          />
        )}
        {isState && (
          <TextInput
            value={searchWord}
            onChange={(e) => handleSearch(e)}
            placeholder={placeholder}
            rightSection={searchWord === '' ? <IconSearch size={16} /> : <IconX onClick={resetSearch} size={16} />}
            w={width}
            styles={{
              input: { paddingInlineStart: '8.5rem' },
            }}
          />
        )}
        <Select
          maw="8rem"
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            input: {
              borderTopRightRadius: '0',
              borderBottomRightRadius: '0',
            },
          }}
          value={searchType || 'all'}
          onChange={setSearchType}
          data={searchOptions}
        />
      </Box>
      {showSearchButton && (
        <Button
          onClick={(e: React.MouseEvent<HTMLButtonElement>) => {
            if (onClickSearch) {
              onClickSearch();
              handleSearch(e);
            } else {
              handleSearch(e);
            }
          }}
          size="sm"
        >
          검색
        </Button>
      )}
      {showResetButton && (
        <Button onClick={resetSearch} variant="transparent" leftSection={<IconRefresh size={16} />}>
          초기화
        </Button>
      )}
    </Flex>
  );
}
